export enum BracketStyle {
  DIAGONAL = 'diagonal_bracket',
  L = 'l_bracket',
  L_WITH_DIAGONAL = 'l_with_diagonal_bracket',
  TEXWIN_ARCHED_CORBEL = 'texwin_arched_corbel',
  TEXWIN_STRAIGHT_CORBEL = 'texwin_straight_corbel',
  TEXWIN_MODERN_CORBEL = 'texwin_modern_corbel',
}
